module.exports = __webpack_public_path__ + "assets/img/dzh-26.9b2b8238.jpg";